import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { RuleSetOption } from '../types';

export abstract class IntegrityMonitorAssignRulesFormBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getRuleSetOptions(): Promise<Array<RuleSetOption>>;
  public abstract assignRulesToRuleSets(
    companyId: string,
    ruleIds: Array<string>,
    ruleSetIds: Array<string>
  ): Promise<Object | null>;
}
